import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Card, Stack, CardHeader } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
// import AddDesignation from './components/AddDesignation'
import { useUserDetails } from "../../context/auth";
import { gql } from "graphql-request";
const OTMaster = () => {
  const navigate = useNavigate();

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const getalldetails = gql`
   query OT {
      allOt {
        data{
             id
        maximumHours
        otPerhourCharge
        }
     
      }
    }
  `;
  //   const getList = () => {
  //     axios({
  //       url: BASEURL,
  //       method: "GET",
  //     })
  //       .then((res) => {
  //         console.log(res);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   };

  //   useEffect(() => {
  //     getList();
  //   }, []);
  const [designationList, setDesignationList] = useState([]);

  const { display, setdisplay, AccessData } = useUserDetails();

  useEffect(() => {
    onDesignationSubmit();
  }, []);

  const convertSecondsToHours = (seconds) => {
    return Math.floor(seconds / 3600); // Return only the number of hours
  };

  const designationListTable = {
    columns: [
      {
        field: "maximumHours",
        headerName: "Maximum Hour",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "otPerhourCharge",
        headerName: "Amount",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],
  };

  const handleNewDesignation = () => {
    setdisplay(false);
    navigate("/OTMaster/add-OT");
  };

  const onDesignationListClick = (e) => {
    console.log("onDesignationListClick:", e?.id, e);
    setdisplay(true);
    if (e?.id) {
      navigate(`/OTMaster/add-OT?id=${e?.id}`);
    }
  };

  const onDesignationSubmit = async () => {
    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: getalldetails,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Extract department data from the response
      const designationList = response.data?.data?.allOt?.data;
      console.log("designationList:", designationList);

      let alldata = designationList
      .map((val) => ({
        id: val.id,
        maximumHours: convertSecondsToHours(val.maximumHours) + " Hours",
        otPerhourCharge: val.otPerhourCharge,
      }))
      .sort((a, b) => b.id - a.id); // Corrected Sorting Logic
    

      console.log("alldataalldata:", alldata);

      setDesignationList(alldata);
      setPageState({ ...pageState, loading: false, state: "success" });

      console.log("Response:", designationList);
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  OT Master list
                </MaterialTypography>
                {/* <MaterialTypography variant="caption" color="text">
                                List of designation that you can get details of designation.
                            </MaterialTypography> */}
              </Stack>

              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "AddOTMaster" && item.can_access
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewDesignation()}
                  >
                    Add OT
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={designationList}
          customHeight={500}
          columns={designationListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onDesignationListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No designation found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any designation details. Click on the
                  "Add designation" button to start adding designation details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default OTMaster;
